<script lang="ts">
  import type { WithElementRef } from 'bits-ui';
  import type { HTMLAttributes } from 'svelte/elements';
  import { cn } from '$lib/utils';

  let {
    class: className,
    ref = $bindable(null),
    children,
    ...restProps
  }: WithElementRef<HTMLAttributes<HTMLDivElement>> = $props();
</script>

<div
  bind:this={ref}
  class={cn(
    'bg-card-luxury text-card-foreground border-border/70 lifted-edge shadow-luxury rounded-xl border',
    className,
  )}
  {...restProps}
>
  {@render children?.()}
</div>
